export default __webpack_public_path__ + "static/cursor_click_06-d6490b03416c9150262212f99e0ab270.wav";